import Vue from 'vue'
import humps from 'humps'

// API resources
import apiMissions from '@/api/modules/missions'
import apiProducts from '@/api/modules/products'
import apiCustomers from '@/api/modules/customers'

// Mutations
import {
  ADD_ONGOING_MISSIONS,
  ADD_MISSION_EVENT,
  ADD_MISSION,
  UPDATE_MISSION_WIZARD,
  ADD_MISSION_PRODUCTS,
  RESET_MODULE
} from '@/store/mutation-types'

// Default state
const getDefaultState = () => {
  return {
    wizard: {
      kind: 'private',
      filters: []
    },
    products: [],
    ongoingMissions: []
  }
}
const state = getDefaultState()

// -----------------------------------------------------------------------------
const actions = {
  fetchOngoingMissions (context) {
    return apiMissions.fetchOngoingMissions()
      .then(data => {
        context.commit(ADD_ONGOING_MISSIONS, data.missions)
      })
      .catch(response => {
        return Promise.reject(response)
      })
  },

  fetchMissionById ({ commit, getters }, { id, cached = true }) {
    let mission
    if (cached && (mission = getters.getById(id))) {
      return Promise.resolve(mission)
    }

    return apiMissions.fetchMissionById(id)
      .then(data => {
        commit(ADD_MISSION, data.mission)
        return Promise.resolve(data.mission)
      })
      .catch(response => {
        return Promise.reject(response)
      })
  },

  fetchCustomerMissions ({ commit, dispatch }, customerId) {
    return apiCustomers.fetchCustomerMissions(customerId)
      .then(data => {
        commit(ADD_ONGOING_MISSIONS, data.missions)

        return Promise.all(data.missions.map(mission => dispatch('fetchCustomerLead', { missionId: mission.id, customerId })))
          .then(data => {
            return Promise.resolve(data.map(lead => {
              if (lead) {
                commit(ADD_MISSION_EVENT, lead)
              }
            }))
          })
      })
      .catch(response => {
        return Promise.reject(response)
      })
  },

  fetchCustomerLead (context, { missionId, customerId }) {
    return apiMissions.fetchCustomerLead(missionId, customerId)
      .then(data => {
        return Promise.resolve(data.lead)
      })
      .catch(response => {
        return Promise.resolve()
      })
  },

  fetchProducts ({ commit }) {
    return apiProducts.fetchProducts()
      .then(data => {
        commit(ADD_MISSION_PRODUCTS, data.products)
        return Promise.resolve(data.products)
      })
      .catch(response => {
        return Promise.reject(response)
      })
  },

  createMission ({ state, dispatch }) {
    let payload = humps.decamelizeKeys({ mission: state.wizard })

    return apiMissions.createMission(payload)
      .then(data => {
        dispatch('fetchOngoingMissions')
        return data
      }).catch(response => {
        return Promise.reject(response)
      })
  },

  updateCustomerMission (context, { missionId, customerId, payload }) {
    return apiMissions.updateCustomerMission(missionId, customerId, payload)
      .then(data => {
        return Promise.resolve(data)
      })
      .catch(response => {
        return Promise.reject(response)
      })
  },

  updateWizard ({ commit }, data) {
    return commit(UPDATE_MISSION_WIZARD, data)
  },

  resetState (context) {
    context.commit(RESET_MODULE)
  }
}

const mutations = {
  [ADD_ONGOING_MISSIONS] (state, data) {
    Vue.set(state, 'ongoingMissions', data)
  },

  [ADD_MISSION_EVENT] (state, data) {
    const missions = state.ongoingMissions.map(mission =>
      data.missionId === mission.id ? { ...mission, events: data.events } : mission
    )

    Vue.set(state, 'ongoingMissions', missions)
  },

  [ADD_MISSION] (state, data) {
    Vue.set(state, 'ongoingMissions', [...state.ongoingMissions, data])
  },

  [UPDATE_MISSION_WIZARD] (state, payload) {
    Vue.set(state, 'wizard', { ...state.wizard, ...payload })
  },

  [ADD_MISSION_PRODUCTS] (state, payload) {
    Vue.set(state, 'products', payload)
  },

  [RESET_MODULE] (state) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  getById: ({ ongoingMissions }) => (id) => {
    return ongoingMissions.find(mission => mission.id === id)
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations,
  getters
})
